import DocumentIcon from '@/assets/images/icons/document.svg?react';
import useConversationStore, { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';
import cn from '@/utils/merge-class-names';
import type { ContentCommonProps } from './content-common-props';

export default function ContentFile({ message, className }: ContentCommonProps) {
  const [, filename = 'download.txt'] = message.Message.split('|');
  const { resetSelectedMessages } = useConversationStore();
  const { handleInteraction: onInteraction } = useConversationHandlers();

  const handleViewFile = () => {
    resetSelectedMessages([message]);
    onInteraction('preview');
  };

  return (
    <div
      className={cn(
        'relative chat-bubble min-w-0 before:hidden max-w-[calc(80vw-80px)] group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary',
        className,
      )}>
      <div className='mx-auto flex h-full max-w-full items-center gap-2 rounded-md px-2 py-1 group-data-sender:theme-ryuryu:bg-blue-300 group-data-sender:theme-wangyou:bg-teal-200 group-data-sender:theme-threetwoone:bg-purple-100 group-data-sender:theme-eightk:bg-purple-100 group-data-sender:theme-bonglan:bg-red-300 group-data-sender:text-body bg-base-100 text-body'>
        <div className='flex min-w-0 max-w-full flex-1 items-center gap-2'>
          <DocumentIcon className='size-6' />

          <p className='font-mono line-clamp-2 break-all text-body1 desktop:text-h3'>{filename}</p>
        </div>
      </div>

      <button
        type='button'
        className='absolute inset-0 z-10 flex cursor-pointer items-end justify-end rounded-lg data-quote:hidden'
        onClick={handleViewFile}
      />
    </div>
  );
}
